<template>
  <div>
    <div class="d-flex justify-space-between align-center">
      <div class="heading-4">Unagii Performance</div>
      <div
        class="text-6 line-height-25 gray--text clickable"
        @click="chartExpanded = !chartExpanded"
      >
        <div v-if="chartExpanded" class="d-flex align-center">
          <span>Collapse Chart</span>
          <v-icon color="gray--text" small>mdi-chevron-up</v-icon>
        </div>
        <div v-else class="d-flex align-center">
          <span>Expand Chart</span>
          <v-icon color="gray--text" small>mdi-chevron-down</v-icon>
        </div>
      </div>
    </div>
    <performance-chart :chartExpanded="chartExpanded" />
    <vaults-stats class="mt-10" />
    <stake-stats class="mt-10" />
  </div>
</template>

<script>
import OverviewPerformance from "./components/OverviewPerformance";
import PerformanceChart from "./components/PerformanceChart";
import VaultsStats from "./components/VaultsStats";
import StakeStats from "./components/StakeStats";

export default {
  components: {
    OverviewPerformance,
    PerformanceChart,
    VaultsStats,
    StakeStats,
  },
  data: () => ({
    chartExpanded: true,
  }),
};
</script>
